import { connect } from 'react-redux';
import View from './AnnualPropertyTaxView';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import nullableAnnualPropertyTaxSelector from './AnnualPropertyTaxSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  nullableAnnualPropertyTax: nullableAnnualPropertyTaxSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onAnnualPropertyTaxChanged: workflowId => ({ target: { value } }) => {
    let PropertyTax = value;
    if (value === '') {
      PropertyTax = null;
    }
    dispatch(updateData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          PropertyTax,
        },
      },
      workflowId,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
